import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators  } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Brand } from 'src/models/brand';
import { APIcityService } from 'src/services/api-services/api-city-service';
import { HelperService } from 'src/services/helperService';
import { HistoryService } from 'src/services/historyService';
//import { TypeOfDocument } from '../../../typeofdocument/typeofdocument';
import { city } from 'src/services/api-services/api-interfaces/city.interface';
import { Observable, tap } from 'rxjs';
import { APICustomScheduleService } from 'src/services/api-services/api-custom-schedule-service';
import { TranslateService } from '@ngx-translate/core';
import { LookAndFeelWebView } from 'src/models/LookAndFeelWebView';
import { PublicSiteConfig } from 'src/services/publicSiteConfig.service';
import { GetCompaniesService } from '../../../../services/incadea/incadea-services/getCompanies.service';
import { Location, ResponseCompanies } from 'src/services/incadea/incadea-interfaces/responses/ResponseCompanies.interface';
import { IncadeaAppointment } from 'src/services/api-services/api-interfaces/IBAppointmentGET.interface';
import { incadeaChileConfig } from '../../../../services/incadeaChileConfig.service';
import { PublicSiteConfigBaseComponent } from 'src/app/base/publicSiteConfigBase.component';
import { ViewType } from 'src/app/enums/viewType.enum';

@Component({
    selector: 'app-i-schedule-choose',
    templateUrl: './i-schedule-choose.component.html',
    styleUrls: ['./i-schedule-choose.component.sass'],
    standalone: false
})
export class IScheduleChooseComponent extends PublicSiteConfigBaseComponent implements OnInit {
  city?:number
  company?:number
  cityName:String= ""
  Location!: Location[]
  recievedLanguageForCountry:any = history.state.LanguageForCountry as {}
  receivedTokenIncadea: any = history.state.tokenIncadea as {}
  receivedNameCountry: any = history.state.nameCountry as {}
  receivedBackEndCode: any = history.state.BackEndCode as {}
  receivedOnlyInchcapeRetail: any = history.state.onlyInchcapeRetail as {}
  public receivedScheduleDatat:IncadeaAppointment = history.state.schedule as IncadeaAppointment
  utmParams:any = history.state.utmParams as {}
  imagen_banner :any
  brand = {} as Brand;
  webview = {} as Brand;
  brandName=''
  companyName:any
  TextForWorkshopScheduleAppointments: string=''
  cities$: Observable<city[]> = new Observable<city[]>();
  companies!: ResponseCompanies []
  areFiltersLoading: boolean = true;
  isLoading: boolean = true;
  chooseServiceWorkshopUrl=''
  chooseServiceUrl=''
  companiesSelect?:ResponseCompanies
  locationSelect?:any
  arrayLocations: Location[] = []
  indexbrandNumber: number = 0;
  BrandsSelect :string=""
  diableDerco:boolean=false
  Brands: any = [
    {
        "Link": "",
        "Description": "Mazda"
    },
    {
        "Link": "",
        "Description": "Suzuki"
    },
    {
        "Link": this.incadeaChileConfig.adressDercoIncadea,
        "Description": "Renault"
    },
    {
        "Link": this.incadeaChileConfig.adressDercoIncadea,
        "Description": "Haval"
    },
    {
        "Link":this.incadeaChileConfig.adressDercoIncadea,
        "Description": "Greatwall"
    },
    {
        "Link": this.incadeaChileConfig.adressDercoIncadea,
        "Description": "Changan"
    },
    {
      "Link": this.incadeaChileConfig.adressDercoIncadea,
      "Description": "Jac"
    },
    {
      "Link": this.incadeaChileConfig.adressDercoIncadea,
      "Description": "Great Wall"
    }
  ];
  emptyschedule: IncadeaAppointment =
  {
    AppointmentId:          "",
    DocumentNo:             "",
    CompanyId:              "",
    CompanyName:            "",
    LocationId:             "",
    VIN:                    "",
    LicenseNo:              "",
    Make:                   "",MakeName:"",
    Department:             "",
    CustomerId:             "",
    DocumentTypeId:        0,
    CustomerName:           "",
    CustomerPhoneNo:        "",
    CustomerPhoneType:      "",
    CustomerEmail:          "",
    LocationName:           "",
    CustomerEmailType:      "",
    TimeslotFrom:           "",
    PreferredPaymentMethod: "",
    IsCustomerPresent:      true,
    Comment:                "",
    SchedulerStatusId:     0,
    CountryName:            "",
    Resources:              [{ResourceId:"",
    ResourceName:""}],
    Services:             [{ServiceId:"",
    ServiceName:""
  }],
    Start: "" ,
    End: "" ,
    DataPrivacyConsent:    [{
      Beneficiary:"",
      CommunicationChannels:"",
      CreatedOn:"",
      Description:"",
      ExpirationDate:"",
      PurposeType:""}],
      Representative : [{
        DocumentNumber:           "",
        Email:                    "",
        RepresentativeFullName:  "",
        RepresentativeId:         "",
        DocumentType:0,
    }]
  }

  //Validaciones
  ScheduleAppointmentForm = this.formBuilder.group({
    company: ['', Validators.required],
    location: ['', Validators.required],
    Brand: ['']
  })
  
  get companyControl(): FormControl{
    return this.ScheduleAppointmentForm.get("company") as FormControl;
  }

  get locationControl(): FormControl{
    return this.ScheduleAppointmentForm.get("location") as FormControl;
  }

  constructor(
    public getCompaniesService: GetCompaniesService,
    public helperService: HelperService,
    public navigation: HistoryService,  
    public customScheduleService: APICustomScheduleService,
    private formBuilder: FormBuilder,
    public cityServiceApi: APIcityService,
    private translate: TranslateService,
    private router: Router,
    public incadeaChileConfig:incadeaChileConfig,
    public override publicSiteConfig:PublicSiteConfig,
    private route: ActivatedRoute) 
  { 
    super(publicSiteConfig, ViewType.Incadea);
    if(!this.indexbrand || !this.indexCountry || !this.recievedCountryData){
        this.route.params.subscribe(params => {
          this.indexbrand = params['brand'];
          this.indexCountry = params['country'];
        });
        const bannermanagementURL = `WebView/i-bannerManage/${this.indexbrand}/${this.indexCountry}`
        this.router.navigate([bannermanagementURL]);  
      }
   
    this.chooseServiceWorkshopUrl=`/WebView/i-create-appoiment/${this.recievedBrandData}/${this.recievedCountryData}`     
  }

  protected override afterConfigLoaded(): void {
    this.imagen_banner = this.CurrentBrand.imagen_banner2;
    this.getCompanyDataFromService();

    if(this.indexbrand === 8){this.diableDerco = true}

    if(this.receivedScheduleDatat) {
      this.emptyschedule = this.receivedScheduleDatat 
      this.ScheduleAppointmentForm.patchValue({
        location:this.receivedScheduleDatat.LocationId
      });
      if(this.indexbrand === 8){
        this.BrandsSelect = this.capitalizeFirstLetter(this.receivedScheduleDatat.MakeName)
        this.diableDerco = false
      } 
    }
    else {
      this.emptyschedule = {
        AppointmentId:          "",
        DocumentNo:             "",
        CompanyId:              "",
        CompanyName:            "",
        LocationId:             "",
        VIN:                    "",
        LicenseNo:              "",
        IsCustomerPresent:      true,
        Make:                   "",MakeName: "",
        Department:             "",
        CustomerId:             "",
        DocumentTypeId:        0,
        CustomerName:           "",
        CustomerPhoneNo:        "",
        CustomerPhoneType:      "",
        CustomerEmail:          "",
        CustomerEmailType:      "",
        TimeslotFrom:           "",
        LocationName:           "",
        PreferredPaymentMethod: "",
        Comment:                "",
        SchedulerStatusId:     0,
        CountryName:            "",
        Resources:              [{ResourceId:"",
        ResourceName:""}],
        Services:             [{ServiceId:"",
        ServiceName:""
      }],
        Start: "" ,
        End: "" ,
        DataPrivacyConsent:    [{
          Beneficiary:"",
          CommunicationChannels:"",
          CreatedOn:"",
          Description:"",
          ExpirationDate:"",
          PurposeType:""}],
          Representative : [{
            DocumentNumber:           "",
            Email:                    "",
            RepresentativeFullName:  "",
            RepresentativeId:         "",
            DocumentType:0
        }]
      }
    }
    
    this.brandName =this.CurrentBrand.name
    this.TextForWorkshopScheduleAppointments= this.translate.instant('TextForWorkshopScheduleAppointment', {
      brandName: this.brandName
    });
  }
   
  //validaciones 
  capitalizeFirstLetter(text: string): string {
    if (text.length === 0) {
        return text;
    }
    
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

  getCompanyDataFromService(){
    this.areFiltersLoading = true
    //evaluate if another things are selected
     this.getCompaniesService.getCompanies(this.receivedTokenIncadea,this.receivedBackEndCode)
    .pipe(
      tap((Response)=>{
        this.isLoading = false
        this.companies=Response
  
        if(Response.length === 1 && Number(this.recievedCountryData) !== 3 ){
          this.companiesSelect = Response[0]
          this.Location = this.companiesSelect.Locations
      

        }
        if(this.receivedOnlyInchcapeRetail === "1"){
          this.companiesSelect = Response[0]
          this.filterCompany(this.companiesSelect)
          if(this.recievedBrandData === "8"){
            Response[0].Description = "Derco Center Tabancura"
          }
          
        }

        if(Number(this.recievedCountryData) === 3 && this.receivedOnlyInchcapeRetail !== "1" ){
          
          switch (this.recievedBrandData){

            case "4":
            
            Response = Response.concat(this.incadeaChileConfig.arrayGeely)
            this.companies=Response 
            
            break;

            case "5":
            
            Response = Response.concat(this.incadeaChileConfig.arraySubaru)
            this.companies=Response 
            
            break;

            case "6":
            
            Response = Response.concat(this.incadeaChileConfig.arrayDfsk)
            this.companies=Response 
            
            break;
            case "8":
            Response[0].Description = "Derco Center Tabancura"
            Response = Response.concat(this.incadeaChileConfig.arrayDerco)
            this.companies=Response 
            
            break;
          }
        }
        this.areFiltersLoading = false
      })
    ).subscribe()
      
  }
 
  filterBrand(Brand:any){
      if(Brand.Link !== ""){  window.top!.location.href= Brand.Link}
      else{
        this.diableDerco = false
        this.emptyschedule.MakeName = Brand.Description
      }
  }

  filterCompany(company: ResponseCompanies){
     

    //When the country is Chile (Id:"3"), the switch case redirects to the URL of each brand
    if(Number(this.recievedCountryData) === 3 ){
      switch (Number(this.recievedBrandData)){

        case 4:
          let filterCompanyGeely = this.incadeaChileConfig.arrayGeely.filter(Response=>Response === company)
          if(filterCompanyGeely.length > 0 ){
            window.top!.location.href= this.incadeaChileConfig.adressGeelyIncadea
            
          }
        break;

        case 5:
          let filterCompanySubaru = this.incadeaChileConfig.arraySubaru.filter(Response=>Response === company)
          if(filterCompanySubaru.length > 0 ){
            window.top!.location.href= this.incadeaChileConfig.adressSubaruIncadea
            
          }
        break;

        case 6:
          let filterCompanyDfsk = this.incadeaChileConfig.arrayDfsk.filter(Response=>Response === company)
          if(filterCompanyDfsk.length > 0 ){
            window.top!.location.href= this.incadeaChileConfig.adressDfskIncadea
            
          }
        break;
        case 8:
          let filterCompanyDerco = this.incadeaChileConfig.arrayDerco.filter(Response=>Response === company)
          if(filterCompanyDerco.length > 0 ){
            window.top!.location.href= this.incadeaChileConfig.adressDercoIncadea
          }
        break;
      
     }
    }
    
    // Country Chile
    if(Number(this.recievedCountryData) === 3){
      this.arrayLocations=[]
      switch (Number(this.recievedBrandData)){
        case 4:
          //Comenting location as the company locations is only 2
          //this.arrayLocations.push(company.Locations[2])
          break;
        case 5:
          //Removing location 2 as per ticket 22407831
          this.arrayLocations.push(company.Locations[0])

            //this.arrayLocations.push(company.Locations[2])
          break;
        case 6:    
            this.arrayLocations.push(company.Locations[1])
          break;
        case 8:
          //Comenting location as the company locations is only 2
            //this.arrayLocations.push(company.Locations[3])
            // this.arrayLocations.push(company.Locations[4])
          
          break;
        }
      
      
      this.Location=this.arrayLocations
    }
    
    this.companiesSelect =company
    if(Number(this.recievedCountryData) !== 3){
      
      this.Location = company.Locations
    }
    
  }

  filterLocation(Location: any){
    // console.log('loca',Location)
    
    this.locationSelect =Location
    
  }  
}
